module.exports = __webpack_public_path__ + "Poppins-Thin.ecbc7cb6ea1863ba4e00.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Thin.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Thin.woff2
// module chunks = styles